import dayjs from 'dayjs';

/**
 * Field configs and DATE_TIME_LOCALE still use date-fns tokens from the MUI
 * pickers (e.g. 'dd/MM/yyyy HH:mm'), but antd's DatePicker formats/parses with
 * dayjs, where `yyyy` isn't a token (rendered literally, so the year never
 * shows/parses) and `dd` means weekday. Translate the tokens that differ.
 */
export const toDayjsFormat = (format?: string): string | undefined =>
  format
    ?.replace(/y{4}/g, 'YYYY')
    .replace(/y{2}/g, 'YY')
    .replace(/d{2}/g, 'DD')
    .replace(/(^|[^D])d(?!d)/g, '$1D');

// Only `disablePast` restricts the calendar. `disableFutureDate` in the field
// configs was never enforced by these pickers, and honouring it blocked every
// future date/year (e.g. New Activity's Planned Start Date), so it stays ignored.
export const getDisabledDate = (field: any) => {
  if (field?.disablePast) return (current) => current && current < dayjs().startOf('day');
  return undefined;
};
